import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

function Ouput() {

}

@Component({
	selector: 'app-input',
	templateUrl: './input.component.html',
	styleUrls: ['./input.component.css']
})
export class InputComponent implements OnInit {

	@Input() placeholder: string;
	@Input() label: string;
	@Input() type: string;
	@Input() maxLength: number;
	@Input() valueInput: any;

	@Output() value = new EventEmitter<string>();

	constructor() {
	}

	ngOnInit() {
	}

	onChange(event) {
		this.value.emit(event.target.value);
	}
}
